import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import editIcon from '../assets/img/icons/edit-primary.svg';

function AdminsTableRow({ item }) {
  const { id, serial, firstName, lastName, email, status } = item;

  return (
    <>
      <td>{serial}</td>
      <td>{firstName}</td>
      <td>{lastName}</td>
      <td>{email}</td>
      <td>{status}</td>
      <td style={{ display: 'flex' }}>
        <Button
          className="btn-icon rounded-circle btn-ghost-light"
          id={`tooltip${id}`}
          size="sm"
          type="button"
        >
          <img src={editIcon} alt="Edit icon" />
        </Button>
      </td>
    </>
  );
}

AdminsTableRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default AdminsTableRow;
